export default __webpack_public_path__ + "static/media/BrainBreak cards86.243ad109.png";